export var getTheme = function getTheme(theme) {
  return require("./".concat(theme, ".css"));
};